/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelvin measures an absolute quantity from true zero, like counting a distance from a starting line rather than measuring how far above an arbitrary reference point you are. By SI convention it's written as '300 K,' not '300°K,' the same way you'd write '5 meters,' not '5°meters.'`)
};

const es_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque Kelvin mide una cantidad absoluta desde el verdadero cero, como contar una distancia desde una línea de salida en lugar de medir cuán lejos arriba de un punto de referencia arbitrario estás. Por convención SI se escribe como '300 K,' no '300°K,' la misma manera que escribirías '5 metros,' no '5°metros.'`)
};

const de_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelvin misst eine absolute Größe ab dem wahren Nullpunkt, ähnlich wie das Zählen einer Entfernung ab einer Startlinie statt der Messung, wie weit man über einem willkürlichen Bezugspunkt liegt. Nach SI-Konvention schreibt man '300 K', nicht '300°K', genauso wie man '5 Meter' schreibt, nicht '5°Meter'.`)
};

const nl_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelvin meet een absolute hoeveelheid vanaf echt nul, zoals het tellen van een afstand vanaf een startlijn in plaats van te meten hoe ver boven een willekeurig referentiepunt u bent. Volgens SI-conventie wordt het geschreven als '300 K,' niet '300°K,' op dezelfde manier als u '5 meter' zou schrijven, niet '5°meter.'`)
};

const fr_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelvin mesure une quantité absolue à partir du vrai zéro, comme compter une distance à partir d'une ligne de départ plutôt que de mesurer la distance au-dessus d'un point de référence arbitraire. Par convention SI, il s'écrit '300 K,' pas '300°K,' de la même manière que vous écririez '5 mètres,' pas '5°mètres.'`)
};

const it_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché Kelvin misura una quantità assoluta da vero zero, come contare una distanza da una linea di partenza piuttosto che misurare quanto sei sopra un punto di riferimento arbitrario. Per convenzione SI è scritto come '300 K,' non '300°K,' allo stesso modo in cui scriveresti '5 metri,' non '5°metri.'`)
};

const pt_br2_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque Kelvin mede uma quantidade absoluta a partir do zero verdadeiro, como contar uma distância a partir de uma linha de partida em vez de medir quão longe acima de um ponto de referência arbitrário você está. Por convenção SI é escrito como '300 K,' não '300°K,' da mesma forma que você escreveria '5 metros,' não '5°metros.'`)
};

const pt_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque Kelvin mede uma quantidade absoluta a partir do zero verdadeiro, como contar uma distância a partir de uma linha de partida em vez de medir a que distância acima de um ponto de referência arbitrário está. Por convenção SI é escrito como '300 K', não '300°K', da mesma forma que escreveria '5 metros', não '5°metros'.`)
};

const ja_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケルビンは真のゼロからの絶対量を測定します。スタート行から距離をカウントすることのように、任意の参照点の上でどのくらい離れているかを測定する必要はありません。SI慣例により、これは「300 K」と表記されており、「300°K」ではなく、「5メートル」と書く方法と同じです。「5°meters」ではなく。`)
};

const zh_uc_temp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq2_a", locale)
	if (locale === "en") return en_uc_temp_faq2_a(inputs)
	if (locale === "es") return es_uc_temp_faq2_a(inputs)
	if (locale === "de") return de_uc_temp_faq2_a(inputs)
	if (locale === "nl") return nl_uc_temp_faq2_a(inputs)
	if (locale === "fr") return fr_uc_temp_faq2_a(inputs)
	if (locale === "it") return it_uc_temp_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq2_a(inputs)
	if (locale === "pt") return pt_uc_temp_faq2_a(inputs)
	if (locale === "ja") return ja_uc_temp_faq2_a(inputs)
	return zh_uc_temp_faq2_a(inputs)
};